import { createRouter, createWebHistory } from 'vue-router'
import LogIn from '@/components/LogIn.vue';
import SignUp from '@/components/SignUp.vue';
import DashBoard from '@/components/DashBoard.vue';
import MagicLink from '@/components/MagicLink.vue';
import ConfirmSignIn from '@/components/ConfirmSignIn.vue';
import { auth } from '@/firebase';
import LoginPage from '../views/loginPage.vue'
import AnalysisView from '../views/AnalysisView.vue'
import CoachDigView from '@/views/CoachDigView.vue'
import MentorView from '@/views/MentorView.vue'
import CoachElon from '@/views/CoachElon.vue'
import CoachMarketer from '@/views/CoachMarketer.vue'
import InterbotView from '@/views/InterbotView.vue'; 
import ChatView from '@/demos/ChatView.vue'; 
import CreateVacancy from '@/components/CreateVacancy.vue';
import JobApplication from '@/views/JobApplication.vue';
import LandingPage from '../views/LandingPage.vue'
import TermsPage from '../views/TermsPage.vue'
import DirectChatView from '../views/DirectChatView.vue'
import CreateJobDescriptionView from '../views/CreateJobDescriptionView.vue'
import EmpresasPage from '../views/EmpresasPage.vue'

const routes = [
  { path: '/login', component: LogIn, meta: { requiresAuth: false} },
  { path: '/signup', component: SignUp, meta: { requiresAuth: false} },
  { path: '/magic-link', component: MagicLink, meta: { requiresAuth: false} },
  { path: '/confirm-sign-in', component: ConfirmSignIn, meta: { requiresAuth: false} },
  { path: '/dashboard', component: DashBoard, meta: { requiresAuth: true} },
  {
    path: '/home',
    name: 'Login',
    component: LoginPage
    , meta: { requiresAuth: false} 
  },
  {
    path: '/jobdesc',
    name: 'JobDescription',
    component: CreateJobDescriptionView
    , meta: { requiresAuth: false} 
  },
  {
    path: '/',
    name: 'Landing',
    component: LandingPage
    , meta: { requiresAuth: false} 
  },
  {
    path: '/empresas',
    name: 'Empresas',
    component: EmpresasPage
    , meta: { requiresAuth: false} 
  },
  {
    path: '/terms',
    name: 'Terms',
    component: TermsPage
    , meta: { requiresAuth: false} 
  },
  {
    path: '/chat',
    name: 'DirectChat',
    component: DirectChatView
    , meta: { requiresAuth: false} 
  },
  {
    path: '/job/:id',
    name: 'Applicar',
    component: JobApplication
    , meta: { requiresAuth: false} 
  },
  {
    path: '/voz',
    name: 'demoVoz',
    component: ChatView 
    , meta: { requiresAuth: false} 
  },
  {
    path: '/coachdigital',
    name: 'CoachDigital',
    component: CoachDigView,
    meta: { requiresAuth: false} 
  },
  {
    path: '/coachelon',
    name: 'CoachElon',
    component: CoachElon,
    meta: { requiresAuth: false} 
  },
  {
    path: '/coachmarket',
    name: 'CoachMarketer',
    component: CoachMarketer,
    meta: { requiresAuth: false} 
  },
  {
    path: '/mentor',
    name: 'Mentores',
    component: MentorView,
    meta: { requiresAuth: false} 
  },
  {
    path: '/interbot',
    name: 'Interbot',
    component: InterbotView,
    meta: { requiresAuth: false} 
  },
  {
  path: '/analysis',
        name: 'AnalysisView',
        component: AnalysisView,
        meta: { requiresAuth: false} 
  },
  {
      path: '/create-vacancy',
      name: 'create-vacancy',
      component: CreateVacancy,
      meta: { requiresAuth: true} 
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  const currentUser = await new Promise((resolve) => {
      auth.onAuthStateChanged(resolve)
  })
   if (to.path === '/' && currentUser) {
      return '/dashboard';
  }
  if(to.meta.requiresAuth && !currentUser) {
    return '/login'
  }
});

export default router;